/** @format */

import { ReactNode } from "react";
import styled from "styled-components";
import { ContentsWrapper } from "./ContentsWrapper";
import { Header } from "./Header";
import { Footer } from "./Footer";
import useInquiryNavHooks from "../../hooks/useInquiryNavHooks";
import useContainerHooks from "../../hooks/useContainerHooks";
import useInquirySendHooks from "../../hooks/useInquirySendHooks";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import { InquiryModalElement, InquiryNavElement, InquirySlideInElement } from "../ui_elements";
import CloseDatePopUp from "../ui_elements/ocnk/Container/CloseDatePopUp";
import { Loading } from "../ui-parts/ocnk/Loading";
import EntryGuide from "../ui-parts/EntryGuide/EntryGuide";

const ContainerWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const Container = ({
  isLogin = false,
  isInquiry = false,
  background = "default",
  align = "center",
  fullwidth = false,
  children = <></>,
  redirect,
  showClosingNoticeText = true,
}: {
  isLogin?: boolean;
  isInquiry?: boolean;
  background?: string;
  align?: string;
  fullwidth?: boolean;
  children?: ReactNode;
  closingNoticeText?: string;
  redirect?: boolean;
  showClosingNoticeText?: boolean;
}) => {
  const { navigateByAgent } = useNavigateByAgent();
  const { isLoading, canceledFlag, closeState, closingNoticeText, agentName } = useContainerHooks(
    isLogin,
    navigateByAgent,
  );
  const {
    InquiryData,
    InquiryCommentData,
    accordionNum,
    path,
    serchInquiryData,
    nonClosedCount,
    toggle,
    toggleChangeHandler,
    inquiryCount,
    naviToggleChangeHandler,
    naviFlag,
    slideInShowFlag,
    EntryGuideShowFlag,
  } = useInquiryNavHooks(isLogin, navigateByAgent);

  const {
    isSubmitted,
    isModalOpen,
    selectOption,
    modalOpenHandler,
    setInquiryRegisterHandler,
    inquiryRegisterHandler,
    errMsg,
    zAccount,
  } = useInquirySendHooks(navigateByAgent);
  return (
    <ContainerWrap>
      {/* ローディング画面 */}
      <Loading isLoading={isLoading} />
      {/* ヘッダー */}
      <Header
        isLogin={isLogin}
        isModalOpen={isModalOpen}
        modalOpenHandler={modalOpenHandler}
        canceledFlag={canceledFlag}
        navigateByAgent={navigateByAgent}
        closeState={closeState}
        redirect={redirect}
        agentName={agentName}
        path={path}
        zAccount={zAccount}
        showClosingNoticeText={showClosingNoticeText}
      />
      {isInquiry && InquiryData.length !== 0 && (
        <InquiryNavElement
          InquiryData={InquiryData}
          toggle={toggle}
          toggleChangeHandler={toggleChangeHandler}
          nonClosedCount={nonClosedCount}
        />
      )}
      {/* 画面クローズ通知 */}
      {closeState.confirm_flag && isLogin && showClosingNoticeText && <CloseDatePopUp closeText={closingNoticeText} />}
      <ContentsWrapper background={background} align={align} fullwidth={fullwidth}>
        {children}
      </ContentsWrapper>
      {/* 不備スライドイン */}
      {isLogin && slideInShowFlag && inquiryCount.active !== 0 && (
        <InquirySlideInElement
          inquiryCount={inquiryCount}
          naviToggleChangeHandler={naviToggleChangeHandler}
          naviFlag={naviFlag}
          InquiryCommentData={InquiryCommentData}
          serchInquiryData={serchInquiryData}
          accordionNum={accordionNum}
        />
      )}
      {/* お問い合わせモーダル */}
      {isModalOpen && (
        <InquiryModalElement
          isSubmitted={isSubmitted}
          errMsg={errMsg}
          selectOption={selectOption}
          modalOpenHandler={modalOpenHandler}
          setInquiryRegisterHandler={setInquiryRegisterHandler}
          inquiryHandler={inquiryRegisterHandler}
        />
      )}
      {/* 申し込みガイド */}
      {EntryGuideShowFlag && <EntryGuide path={path} zAccount={zAccount} />}
      <Footer />
    </ContainerWrap>
  );
};
